import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=66e938a0&scoped=true&"
import script from "./NotificationList.vue?vue&type=script&lang=js&"
export * from "./NotificationList.vue?vue&type=script&lang=js&"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=66e938a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e938a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66e938a0')) {
      api.createRecord('66e938a0', component.options)
    } else {
      api.reload('66e938a0', component.options)
    }
    module.hot.accept("./NotificationList.vue?vue&type=template&id=66e938a0&scoped=true&", function () {
      api.rerender('66e938a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notifications/NotificationList.vue"
export default component.exports